import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency, DEFAULT_CURRENCY } from '../../utils/currencyUtils';
import { BRAND } from '../../theme/brandTokens';

const summaryCardSx = {
  flex: 1,
  p: 2,
  borderRadius: 2,
  border: `1px solid ${BRAND.line}`,
  backgroundColor: BRAND.background,
};

const MembershipPeriodUsageSummary = ({
  detail,
  currencyCode = DEFAULT_CURRENCY,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <Box sx={summaryCardSx}>
        <Typography variant="caption" color="text.secondary">
          {t('employeePayments.payroll.membershipPeriod.gross')}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.primaryText }}>
          {formatCurrency(detail.grossAmount, currencyCode)}
        </Typography>
      </Box>
      <Box sx={summaryCardSx}>
        <Typography variant="caption" color="text.secondary">
          {t('employeePayments.payroll.membershipPeriod.storeMargin')}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.primaryText }}>
          {formatCurrency(detail.storeMarginAmount, currencyCode)}
        </Typography>
      </Box>
      <Box sx={summaryCardSx}>
        <Typography variant="caption" color="text.secondary">
          {t('employeePayments.payroll.membershipPeriod.barberPool')}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.primaryText }}>
          {formatCurrency(detail.barberPoolAmount, currencyCode)}
        </Typography>
      </Box>
      <Box sx={summaryCardSx}>
        <Typography variant="caption" color="text.secondary">
          {t('employeePayments.payroll.membershipPeriod.unallocated')}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.primaryText }}>
          {formatCurrency(detail.unallocatedAmount, currencyCode)}
        </Typography>
      </Box>
    </Stack>
  );
};

export default MembershipPeriodUsageSummary;
